import React, { useEffect } from "react";

function LiveKitPopup({
  agentId,
  agentRoom,
  userForm,
  agentName,
  telephonyToken,
  themeColor
}) {
  useEffect(() => {
    // Load widget script
    const script = document.createElement("script");
    script.src = "https://chat.voiceadmins.com/va-widget.umd.js";
    script.async = true;
    document.body.appendChild(script);

    // Cleanup on unmount
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Fallback for empty agent
  const resolvedAgentId = agentId || "";
  const resolvedAgentRoom = agentRoom || "obs_room";
  const resolvedUserForm = userForm || "No";
  const resolvedAgentName = agentName || "Maya";
  const resolvedTelephonyToken = telephonyToken;
  const resolvedThemeColor = themeColor;

  return (
    <va-widget
      agent-name={resolvedAgentName}
      agent-id={resolvedAgentId}
      agent-room={resolvedAgentRoom}
      form-enabled={resolvedUserForm}
      theme={resolvedThemeColor}
      app-url="https://chat.voiceadmins.com/embed"
      telephony-token={resolvedTelephonyToken}
      domain-name={process.env.REACT_APP_DOMAIN_NAME}
    ></va-widget>
  );
}

export default LiveKitPopup;
